import Center from './src/center-combined';
export default Center;